<template>
    <div class="check-email"
        v-loading="loading"
    >
    </div>
</template>

<script>
import { activeReg } from '@/api/user.js'
import { setLocalStorage } from '@/utils/common';

export default {
    name: 'check-email',
    data() {
        return {
            querys:{},
          loading: false,
        }
    },
    methods: {
        setLocalStorage,
        checkEmail(){
          this.loading = true;
            activeReg(this.querys).then((res) => {
              this.loading = false;
                localStorage.setItem('token',res.data.token)
                this.setLocalStorage('userInfo',res.data.cust);
              this.$store.commit('setUserInfo', res.data.cust);
                this.setLocalStorage('custStatus',res.data.cust.custStatus);
                if(res.data.cust.custStatus == 1){
                    this.$router.push({
                        name:'perfectInfo'
                    });
                }else {
                    this.$router.push({
                        name:'dashboard'
                    });
                }
            }).catch((err) => {
                this.$router.push({
                        path:'/login'
                })
            });
        }
    },
    created() {
        this.querys = this.$route.query;
        this.checkEmail()
    },
};
</script>

<style scoped lang="scss">
    .check-email {
        height: 100%;
        width: 100%;
    }
</style>
